import { gql } from '__generated__';

export default gql(`
  mutation EditMailOptIns($input: EditMailOptInsInput!) {
    editMailOptIns(input: $input) {
      id
      granted_mail_permissions {
        id
        title
      }
    }
  }
`);
